import { render, staticRenderFns } from "./CustomerPartCategoryList.vue?vue&type=template&id=22fb931a"
import script from "./CustomerPartCategoryList.vue?vue&type=script&lang=js"
export * from "./CustomerPartCategoryList.vue?vue&type=script&lang=js"
import style0 from "./CustomerPartCategoryList.vue?vue&type=style&index=0&id=22fb931a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports